import { marked } from 'marked'
import DOMPurify from 'isomorphic-dompurify'

export function transformToMarkdownLetter(text: string): string {
  const cleanText = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
  const dirtyHtml = marked(cleanText) as string
  return DOMPurify.sanitize(dirtyHtml)
}

export function transformToMarkdownLetterPlainText(text: string): string {
  const cleanText = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
  const dirtyHtml = marked(cleanText) as string
  return DOMPurify.sanitize(dirtyHtml, { ALLOWED_TAGS: [] })
}
